import type { Member, Project, TimeEntry, WorkspaceState } from './types';

export const PROJECT_COLORS = ['#6C5CE7', '#FF7A68', '#00A896', '#F4B942', '#2F80ED', '#E056A7'];

export const projects: Project[] = [
  { id: 'p1', name: 'Brand refresh', client: 'Northstar Labs', color: '#6C5CE7', budgetHours: 120, hourlyRate: 115, active: true },
  { id: 'p2', name: 'Growth sprint', client: 'Brightside', color: '#FF7A68', budgetHours: 80, hourlyRate: 105, active: true },
  { id: 'p3', name: 'Product discovery', client: 'Nova Works', color: '#00A896', budgetHours: 96, hourlyRate: 125, active: true },
  { id: 'p4', name: 'Internal operations', client: 'T3 Studio', color: '#F4B942', budgetHours: 48, hourlyRate: 0, active: true },
  { id: 'p5', name: 'Website care', client: 'Kindred', color: '#2F80ED', budgetHours: 36, hourlyRate: 95, active: true },
];

export const members: Member[] = [
  { id: 'm1', name: 'Robin Janssen', initials: 'RJ', role: 'Design lead', avatarColor: '#6C5CE7', weeklyCapacity: 32 },
  { id: 'm2', name: 'Maya Patel', initials: 'MP', role: 'Product strategist', avatarColor: '#FF7A68', weeklyCapacity: 32 },
  { id: 'm3', name: 'Noah Williams', initials: 'NW', role: 'Developer', avatarColor: '#00A896', weeklyCapacity: 36 },
  { id: 'm4', name: 'Elsa de Boer', initials: 'EB', role: 'Operations', avatarColor: '#2F80ED', weeklyCapacity: 28 },
];

const at = (daysAgo: number, hour: number, minute: number) => {
  const value = new Date();
  value.setHours(hour, minute, 0, 0);
  value.setDate(value.getDate() - daysAgo);
  return value.toISOString();
};

const entry = (
  id: string,
  description: string,
  projectId: string,
  memberId: string,
  daysAgo: number,
  hour: number,
  minute: number,
  durationMinutes: number,
  billable = true,
  tags: string[] = [],
): TimeEntry => {
  const start = new Date(at(daysAgo, hour, minute));
  const end = new Date(start.getTime() + durationMinutes * 60_000);
  return { id, description, projectId, memberId, tags, start: start.toISOString(), end: end.toISOString(), duration: durationMinutes * 60, billable };
};

export const entries: TimeEntry[] = [
  entry('e1', 'Design system components', 'p1', 'm1', 0, 9, 0, 135, true, ['Design']),
  entry('e2', 'Client alignment call', 'p1', 'm1', 0, 11, 30, 45, true, ['Meeting']),
  entry('e3', 'Campaign experiment review', 'p2', 'm2', 0, 9, 15, 105, true, ['Research']),
  entry('e4', 'API endpoint implementation', 'p3', 'm3', 0, 8, 45, 210, true, ['Development']),
  entry('e5', 'Weekly planning', 'p4', 'm4', 0, 10, 0, 60, false, ['Planning']),
  entry('e6', 'Content model workshop', 'p3', 'm1', 1, 9, 0, 150, true, ['Workshop']),
  entry('e7', 'User interview synthesis', 'p3', 'm2', 1, 10, 0, 180, true, ['Research']),
  entry('e8', 'Responsive QA pass', 'p5', 'm3', 1, 13, 0, 150, true, ['Development']),
  entry('e9', 'Team retro', 'p4', 'm4', 1, 15, 0, 75, false, ['Meeting']),
  entry('e10', 'Visual direction exploration', 'p1', 'm1', 2, 9, 15, 240, true, ['Design']),
  entry('e11', 'Landing page copy', 'p2', 'm2', 2, 10, 30, 165, true, ['Copywriting']),
  entry('e12', 'Prototype architecture', 'p3', 'm3', 2, 8, 30, 270, true, ['Development']),
  entry('e13', 'Finance and resourcing', 'p4', 'm4', 2, 13, 0, 90, false, ['Operations']),
  entry('e14', 'Brand workshop', 'p1', 'm1', 3, 9, 0, 180, true, ['Workshop']),
  entry('e15', 'Analytics review', 'p2', 'm2', 3, 9, 30, 120, true, ['Research']),
  entry('e16', 'Database schema', 'p3', 'm3', 3, 8, 45, 225, true, ['Development']),
  entry('e17', 'Partner catch-ups', 'p4', 'm4', 3, 14, 0, 120, false, ['Meeting']),
  entry('e18', 'Homepage art direction', 'p1', 'm1', 4, 9, 0, 210, true, ['Design']),
  entry('e19', 'Experiment setup', 'p2', 'm2', 4, 10, 0, 195, true, ['Marketing']),
  entry('e20', 'Authentication flow', 'p3', 'm3', 4, 8, 30, 255, true, ['Development']),
  entry('e21', 'People operations', 'p4', 'm4', 4, 13, 30, 105, false, ['Operations']),
  entry('e22', 'Care plan updates', 'p5', 'm3', 5, 10, 0, 180, true, ['Development']),
  entry('e23', 'Strategy notes', 'p2', 'm2', 5, 11, 0, 105, true, ['Planning']),
  entry('e24', 'Component QA', 'p1', 'm1', 6, 9, 30, 150, true, ['Design']),
];

export const seedState: WorkspaceState = { projects, members, entries, runningTimer: null, viewer: { memberId: 'm1' } };
